<template>
  <b-modal
    v-model="modal"
    centered
    modal-class="modal-bb-large modal-size-xl"
    hide-header
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    v-on="$listeners"
  >
    <template slot="default">
      <div v-if="type === 'companies'">
        <h4 class="pb-10">Your startup might already be listed on The Hub</h4>
        <p>
          We matched the name of your startup with a startup profile already
          listed and not yet claimed. If it is your startup listed below, feel
          free to claim and get quicker up and running.
        </p>
      </div>
      <div v-else>
        <h4 class="pb-10">
          You might already be listed on The Hub
        </h4>
        <p>
          We matched the name of the investor profile with an investor already
          listed and not yet claimed. If you are the rightful owner of the
          profile below, feel free to claim and get quicker up and running.
        </p>
      </div>

      <b-row class="pt-16">
        <b-col v-for="(profile, i) in profiles" :key="i" class="py-16" md="4">
          <div class="profile">
            <button class="over-link" @click="$emit('claim', profile)"></button>
            <div
              class="profile-logo"
              :style="
                profile.logoImage
                  ? {
                      backgroundImage:
                        'url(' + profile.logoImage.thumbnailSizeUrl + ')'
                    }
                  : {}
              "
            ></div>

            <div class="profile-name">{{ profile.name }}</div>
            <div class="profile-description">
              {{ profile.description.substr(0, 90) + '...' }}
            </div>

            <div class="spacer"></div>

            <b-button variant="link">Claim this {{ profileLabel }}</b-button>
          </div>
        </b-col>

        <b-col class="py-16" md="4">
          <div class="profile">
            <button class="over-link" @click="modal = false"></button>

            <div class="profile-add">
              <i class="icon-plus"></i>
            </div>
            <div class="profile-name">+ Add a new {{ profileLabel }}</div>
            <div class="profile-description">
              None of these {{ profileLabel }}s is mine, I would like to
              continue creating a new {{ profileLabel }} on The Hub
            </div>
            <div class="spacer"></div>
            <b-button variant="link">Add a new {{ profileLabel }}</b-button>
          </div>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'ProfilesConflictingModal',
  components: {},
  mixins: [validationMixin],
  props: {
    value: {
      type: Boolean,
      required: true
    },
    profiles: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'companies'
    }
  },
  data() {
    return {
      siteKey: process.env.GOOGLE_RECAPTCHA_SITE_KEY,
      promptErrorMessage: undefined,
      isRequesting: false,
      form: {
        company: undefined,
        email: undefined,
        reCaptchaResponse: undefined
      }
    }
  },
  computed: {
    modal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    profileLabel() {
      return this.type === 'companies' ? 'startup' : 'investor'
    }
  },
  methods: {
    async onSubmit() {
      if (this.isRequesting) {
        return
      }

      this.$v.form.$touch() // will trigger errors to appear.

      if (this.$v.form.$error) {
        return
      }

      this.isRequesting = true

      try {
        await this.$axios.post(`subscribe/report`, cloneDeep(this.form))

        this.$emit('subscribed')
      } catch (err) {
        this.promptErrorMessage = err.message
      }

      if (this.$refs.reCaptcha) {
        this.$refs.reCaptcha.reset()
      }

      this.form.reCaptchaResponse = undefined

      this.isRequesting = false
    },
    onVerify(response) {
      this.form.reCaptchaResponse = response
      this.$v.form.reCaptchaResponse.$touch()
    },
    onExpired() {
      this.form.reCaptchaResponse = undefined
      this.$v.form.reCaptchaResponse.$touch()
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      company: {
        required
      },
      reCaptchaResponse: {
        required
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.profile {
  position: relative;
  background-color: #fff;
  padding: rem(30px);
  box-shadow: 0 60px 90px -30px rgba(31, 36, 48, 0.1);
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: box-shadow 0.3s;

  &:hover {
    box-shadow: 0 60px 90px -30px rgba(31, 36, 48, 0.2);
  }

  .over-link {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
  }

  .profile-logo {
    width: 64px;
    height: 64px;
    background: no-repeat center center / cover;
  }

  .profile-add {
    width: 64px;
    height: 64px;
    border: 2px dashed $gray-200;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $blue-900;
  }

  .profile-name {
    padding-top: rem(25px);
    font-size: rem(22px);
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }

  .profile-description {
    padding-top: rem(5px);
    font-size: rem(14px);
    color: $gray-400;
  }

  .spacer {
    flex: 1 1 auto;
  }
}
</style>
